import { render, staticRenderFns } from "./honor-personal.vue?vue&type=template&id=13a35d3d&scoped=true&"
import script from "./honor-personal.vue?vue&type=script&lang=js&"
export * from "./honor-personal.vue?vue&type=script&lang=js&"
import style0 from "./honor-personal.vue?vue&type=style&index=0&id=13a35d3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a35d3d",
  null
  
)

export default component.exports